import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  getSelectedZusatzoptionen,
  GlobalActions,
  GlobalPut,
  UnfCheckoutProduktPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, Produktlinie, UNFALL_TITLE } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { getBezeichnungForPerson } from '@ps20-frontend/gui-components';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { convertDateFormatFromLocalStateToShortIso } from '@ps20-frontend/utils';
import { UnfActions } from '../unfActions';
import { IAppState } from '../appState';
import { UnfFachschluessel } from '../model/unf.enums';
import {
  hasLeistungSelected,
  hasZusatzoptionSelected,
  selectSelectedProduktlinie,
} from '../selector/produkt.selector';

export function* watchInDashboardUebernehmenSaga() {
  yield takeEvery(UnfActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateDashboardData, App.UNF));
  yield takeEvery(UnfActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateProduktData, App.UNF));
}

export function* generateProduktData() {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();

  const produktActionData: UnfCheckoutProduktPayload = {
    appId: App.UNF,
    produktlinie: selectSelectedProduktlinie(state).produktName,
    angebotsId: state.angebotsId,
    uebersichtTitle: UNFALL_TITLE,
    laufzeit: state.vertragsoptionen.vertragslaufzeit,
    versichertesRisiko: getBezeichnungForPerson(state.vp),
    unfallVp: createVp(state),
    beginndatum: state.vertragsoptionen.beginnDatum,
    vorvertragsnummer: state.vertragsoptionen.vorvertragsNummern,
    vorvertragSofortschutz: state.vertragsoptionen.vorvertragSofortschutz,
    angebotsdatum: state.vertragsoptionen.angebotsdatum,
  };
  yield call([globalPut, globalPut.put], new GlobalActions().produktAction(produktActionData));
}

export function* generateDashboardData() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const selectedProduktlinie: Produktlinie = getSelectedProduktlinie(state.produkt);

  yield put(new UnfActions().vorschlagdatenChanged(state.angebotsId));

  const { vorname, nachname, geburtsdatum } = state.vp;

  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().inDashboardUebernehmen({
      appId: App.UNF,
      angebotsId: state.angebotsId,
      kurztext: selectedProduktlinie.kurztext,
      ausgewaehlteLinie: selectedProduktlinie.produktName,
      vertragslaufzeit: state.vertragsoptionen.vertragslaufzeit,
      versichertesRisiko: getBezeichnungForPerson(state.vp),
      versichertePerson: {
        vorname,
        nachname,
        geburtsdatum: convertDateFormatFromLocalStateToShortIso(geburtsdatum),
      },
      selectZusatzoptionen: getSelectedZusatzoptionen(selectedProduktlinie.zusatzoptionen),
      beginn: state.vertragsoptionen.beginnDatum,
    }),
  );
}

const createVp = (state: IAppState): UnfCheckoutProduktPayload['unfallVp'] => {
  const { vorname, nachname, geburtsdatum, kundenverwaltungID } = state.vp;
  return {
    kdvId: kundenverwaltungID,
    vorname,
    nachname,
    geburtsdatum,
    hasTodesfallleistung: hasLeistungSelected(state, UnfFachschluessel.TODESFALL),
    hasKIS: hasZusatzoptionSelected(state, UnfFachschluessel.KINDERINVALIDITAET),
  };
};
